import React from "react";

import { useAppSelector } from "store";
import {
    selectBudgetAndValueOptionsRAG
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";

import RAGIndicator from "components/visuals/RAGIndicatorNew";

const BudgetAndValueOptionsRAG: React.FC = () => {
    const data = useAppSelector(selectBudgetAndValueOptionsRAG);

    return (
        <RAGIndicator ragIndicator={data} />
    );
};

export default BudgetAndValueOptionsRAG;
